import { Subscription } from "rxjs";
import { OnDestroy } from "@angular/core";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { ReCaptchaV3Service } from "ng-recaptcha";
import { ForgetPassObj } from "src/app/models/login";
import { AccountService } from "src/app/services/account.service";
import { AlertService } from "src/app/services/alert.service";
import Swal from "sweetalert2";

@Component({
  selector: "app-verify-email",
  templateUrl: "./verify-email.component.html",
  styleUrls: ["./verify-email.component.scss"],
})
export class VerifyEmailComponent implements OnInit, OnDestroy {
  verifyEmail: ForgetPassObj = {} as ForgetPassObj;
  formForget: FormGroup;
  resetEmail: "";
  private _subscription: Subscription;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private alertService: AlertService,
    private dialog: MatDialog,
    private translate: TranslateService,
    private accService: AccountService,
    private recaptchaV3Service: ReCaptchaV3Service
  ) {}

  ngOnInit() {
    this.formForget = this.formBuilder.group({
      email: [null, [Validators.required, Validators.email]],
    });
  }

  onLogin() {
    this.recaptchaV3Service
      .execute("importantAction")
      .subscribe((token: string) => {
        this.verifyEmail.Email = this.formForget.value.email;
        this.accService.VerifyEmail(this.verifyEmail.Email).subscribe(
          (arg) => {
            Swal.fire({
              position: "center",
              icon: "success",
              title: this.translate.instant("incorrect-email"),
              showConfirmButton: false,
              timer: 4500,
            });
          },
          (err) => {
            Swal.fire({
              position: "center",
              icon: "error",
              title: this.translate.instant("pass-error-msg"),
              showConfirmButton: false,
              timer: 4500,
            });
          }
        );
      });
  }
  login() {
    this.router.navigateByUrl("/login");
  }
  ngOnDestroy() {
    if (this._subscription) {
      this._subscription.unsubscribe();
    }
    const element = document.getElementsByClassName(
      "grecaptcha-badge"
    )[0] as HTMLElement;
    if (element) {
      element.style.visibility = "hidden";
    }
  }
}
